export function isAuthenticated() {
  return !!localStorage.getItem("MFE_TOKEN") && !!localStorage.getItem("MFE_CURRENT_USER");
}

export function getCurrentUser() {
  let currentUser = localStorage.getItem("MFE_CURRENT_USER");
  return currentUser ? JSON.parse(currentUser) : null;
}

export function clearCurrentUser() {
  localStorage.removeItem("MFE_TOKEN");
  localStorage.removeItem("MFE_CURRENT_USER");
}

export function canUserAccessAdminPortal(user) {
    if (!user) {
      return 'User not found';
    }
    if (!user.adminPortalAccess) {
        return 'Please Log In as an Admin Portal User.';
    }

    return null;
}

// Pure derivation: fills in isSystemAdmin on a user object when it is not already present.
// Null-safe — returns the input unchanged when there is no user to derive from.
export function deriveIsSystemAdmin(user) {
  if (!user) {
    return user;
  }
  if (user.isSystemAdmin === undefined) {
    user.isSystemAdmin = user.authorities && user.authorities.length <= 2 && user.authorities.includes('ROLE_ADMIN');
  }
  return user;
}

// Synchronous write of the current user (with isSystemAdmin derived) to localStorage.
// Used by the account refresh so the stored user lands before guarded screens mount —
// useLocalStorage only writes when its setter is called from a mounted component, which doesn't cover that gate.
export function setCurrentUser(user) {
  localStorage.setItem("MFE_CURRENT_USER", JSON.stringify(deriveIsSystemAdmin(user)));
}
